import React from 'react'
import styles from './FJNoMedia.module.less';
import FJLocalStore from "../../../store/FJLocalStore";
import classNames from 'classnames'
import InlineSVG from "react-inlinesvg";
import media from '../../../icon/media icon.svg';

function FJNoMedia(props) {

  let {
    height
  } = props;


  let iconClass;
  if (height <= 328) { // 328是测试出来的数据值
    iconClass = classNames(styles.icon, styles.icon_small);
  } else {
    iconClass = classNames(styles.icon);
  }

  return (
    <>
      <div className={iconClass}>
        <InlineSVG src={media}/>
      </div>
      <p className={styles.desc}>{FJLocalStore._('click-drag-import-file')}</p>
    </>
  )
}

export default FJNoMedia;
